<div class="standardize-execute-wrapper">

    <!-- ============= KHỐI TÌM KIẾM ============= -->
    <mat-accordion #accordion="matAccordion" [multi]="true">
      <mat-expansion-panel expanded="true" class="mt-3">
        <mat-expansion-panel-header>
          <mat-panel-title class="mat-panel-title">
            {{ 'SEARCH_STANDARDIZED_LABOR_EMPLOYEE.SEARCH_STANDARDIZED_LABOR_CONTRACTS' | translate }}
          </mat-panel-title>
        </mat-expansion-panel-header>
  
        <form #executeSearchForm="ngForm" (ngSubmit)="onSearch()" class="pb-3">
          <div class="row">
  
            <!-- Tên / Mã hợp đồng văn bản -->
            <div class="col-lg-4 col-md-4">
              <mat-form-field class="w-100">
                <input type="text"
                       matInput
                       name="nameOrCode"
                       [(ngModel)]="documents.nameOrCode"
                       [placeholder]="'SEARCH_STANDARDIZED_LABOR_EMPLOYEE.CONTRACT_DOCUMENT_NAME_CODE' | translate"
                       maxlength="255"
                       autocomplete="off"
                       (focusout)="documents.nameOrCode = documents.nameOrCode == undefined ? '' : (documents.nameOrCode + '').trim()">
                <button mat-button *ngIf="documents.nameOrCode" type="button" matSuffix mat-icon-button
                        aria-label="Clear" (click)="documents.nameOrCode = ''">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </div>
  
            <!-- Tên/Email bên ký kết -->
            <div class="col-lg-4 col-md-4">
              <mat-form-field class="w-100">
                <input type="text"
                       matInput
                       name="customer"
                       [(ngModel)]="documents.customer"
                       [placeholder]="'SEARCH_STANDARDIZED_LABOR_EMPLOYEE.SIGNING_PARTY_NAME_EMAIL' | translate"
                       maxlength="255"
                       autocomplete="off"
                       (focusout)="documents.customer = documents.customer == undefined ? '' : (documents.customer + '').trim()">
                <button mat-button *ngIf="documents.customer" type="button" matSuffix mat-icon-button
                        aria-label="Clear" (click)="documents.customer = ''">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </div>
  
            <!-- Trạng thái xử lý -->
            <div class="col-lg-4 col-md-4">
              <mat-form-field class="w-100">
                <mat-label>{{ 'SEARCH_STANDARDIZED_LABOR_EMPLOYEE.PROCESSING_STATUS' | translate }} </mat-label>
                <mat-select #statusStandardizedSelect
                            (focusout)="checkFocus = true"
                            (selectionChange)="checkFocus = false"
                            (focus)="commonService.openComboBox(checkFocus, statusStandardizedSelect)"
                            id="statusStandardized"
                            name="statusStandardized"
                            [(ngModel)]="documents.statusStandardized"
                            (ngModelChange)="onSearch()"
                            [disabled]="!executeSearchForm.valid">
                  <mat-option [value]="null" selected
                              (click)="commonService.closeDropdownList(statusStandardizedSelect)">
                    {{ 'common.all' | translate }}
                  </mat-option>
                  <mat-option *ngFor="let item of statusStandardizedOptions"
                              [value]="item.value"
                              (click)="commonService.closeDropdownList(statusStandardizedSelect)">
                    {{ item.label }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
  
            <ng-container *ngIf="showAdvancedSearch">
  
              <!-- Trạng thái của CKS NLĐ -->
              <div class="col-lg-4 col-md-4">
                <mat-form-field class="w-100">
                  <mat-label>{{ 'labor_contract_standardize.execute.table_headers.status_cks_nld' | translate }}</mat-label>
                  <mat-select #statusDigitalCertPersonalSelect
                              (focusout)="checkFocus = true"
                              (selectionChange)="checkFocus = false"
                              (focus)="commonService.openComboBox(checkFocus, statusDigitalCertPersonalSelect)"
                              id="statusDigitalCert"
                              name="statusDigitalCert"
                              [(ngModel)]="documents.statusDigitalCert"
                              (ngModelChange)="onSearch()"
                              [disabled]="!executeSearchForm.valid">
                    <mat-option [value]="null" selected
                                (click)="commonService.closeDropdownList(statusDigitalCertPersonalSelect)">
                      {{ 'common.all' | translate }}
                    </mat-option>
                    <mat-option *ngFor="let item of digitalCertStatusOptions"
                                [value]="item.value"
                                (click)="commonService.closeDropdownList(statusDigitalCertPersonalSelect)">
                      {{ item.label }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </ng-container>
          </div>
  
          <!-- Thu gọn/mở rộng tìm kiếm -->
          <div class="row">
            <div class="col-lg-12 col-md-6 d-flex justify-content-end">
              <button *ngIf="showAdvancedSearch" type="button" mat-button class="advance-search"
                      (click)="toggleAdvancedSearch()">
                <span>{{ 'enterprise_contract.buttons.basic' | translate }}</span>
                <em class="material-icons">keyboard_arrow_up</em>
              </button>
              <button *ngIf="!showAdvancedSearch" type="button" mat-button class="advance-search"
                      (click)="toggleAdvancedSearch()">
                <span>{{ 'enterprise_contract.buttons.advance' | translate }}</span>
                <em class="material-icons">keyboard_arrow_down</em>
              </button>
            </div>
          </div>
  
          <!-- Nút tìm kiếm -->
          <div class="row mt-3">
            <div class="col-lg-12 d-flex justify-content-center">
              <button mat-stroked-button color="primary" type="submit"
                      [disabled]="!executeSearchForm.valid">
                <mat-icon class="mr-0" style="font-weight: 900;">search</mat-icon>
                {{ 'SEARCH_STANDARDIZED_LABOR_EMPLOYEE.SEARCH' | translate }}
              </button>
            </div>
          </div>
        </form>
      </mat-expansion-panel>
    </mat-accordion>
  
    <!-- ============= KHỐI DANH SÁCH ============= -->
    <mat-accordion #accordion="matAccordion" [multi]="true">
      <mat-expansion-panel expanded="true" class="mt-3">
        <mat-panel-title class="mat-panel-title mb-0 pb-3 mt-3 d-flex align-items-center list-title-mine">
          <div class="d-flex justify-content-between align-items-center mt-3 mb-2 list-header">
            <div class="list-title">
              {{ 'SEARCH_STANDARDIZED_LABOR_EMPLOYEE.STANDARDIZED_LABOR_CONTRACT_LIST' | translate }} ({{ paginate.totalRow }})
            </div>
          </div>
        </mat-panel-title>

        <div class="table-responsive">
          <mat-table [dataSource]="dataSource.data"
                     class="w-100 mat-table-col-extra-sm standardize-execute-table">
      
            <!-- STT -->
            <ng-container matColumnDef="stt">
              <mat-header-cell *matHeaderCellDef
                               class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom">
                {{ 'SEARCH_STANDARDIZED_LABOR_EMPLOYEE.NO' | translate }}
              </mat-header-cell>
              <mat-cell *matCellDef="let element"
                        class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom">
                <span class="fix-width">{{ element.stt }}</span>
              </mat-cell>
            </ng-container>
      
            <!-- Mã - Tên hợp đồng/văn bản -->
            <ng-container matColumnDef="codeName">
              <mat-header-cell *matHeaderCellDef class="code-name-col mat-cell-non-boder-right-bottom">
                {{ 'SEARCH_STANDARDIZED_LABOR_EMPLOYEE.CONTRACT_DOCUMENT_CODE_NAME' | translate }}
              </mat-header-cell>
              <mat-cell *matCellDef="let element"
                        [matTooltip]="element.codeName"
                        class="code-name-col mat-cell-non-boder-right-bottom">
                <span class="fix-width">{{ element.codeName || '-' }}</span>
              </mat-cell>
            </ng-container>
      
            <!-- Các bên ký kết -->
            <ng-container matColumnDef="parties">
              <mat-header-cell *matHeaderCellDef class="text-col mat-cell-non-boder-right-bottom">
                {{ 'SEARCH_STANDARDIZED_LABOR_EMPLOYEE.SIGNING_PARTIES' | translate }}
              </mat-header-cell>
              <mat-cell *matCellDef="let element"
                        [matTooltip]="element.parties"
                        class="text-col mat-cell-non-boder-right-bottom">
                <span class="fix-width">{{ element.parties || '-' }}</span>
              </mat-cell>
            </ng-container>
      
            <!-- Email các bên ký kết -->
            <ng-container matColumnDef="emails">
              <mat-header-cell *matHeaderCellDef class="text-col mat-cell-non-boder-right-bottom">
                {{ 'SEARCH_STANDARDIZED_LABOR_EMPLOYEE.SIGNING_PARTIES_EMAIL' | translate }}
              </mat-header-cell>
              <mat-cell *matCellDef="let element"
                        [matTooltip]="element.emails"
                        class="text-col mat-cell-non-boder-right-bottom">
                <span class="fix-width">{{ element.emails || '-' }}</span>
              </mat-cell>
            </ng-container>
      
            <!-- Trạng thái ký NSDLĐ -->
            <!-- <ng-container matColumnDef="statusDigitalCert">
              <mat-header-cell *matHeaderCellDef
                               class="mat-header-cell-center status-col mat-cell-non-boder-right-bottom">
                    {{ 'SEARCH_STANDARDIZED_LABOR_EMPLOYEE.EMPLOYER_SIGNING_STATUS' | translate }}
                  </mat-header-cell>
              <mat-cell *matCellDef="let element"
                        class="mat-header-cell-center status-col mat-cell-non-boder-right-bottom">
                <nz-tag *ngIf="element.statusDigitalCert" [nzColor]="getStatusTagColor(element.statusDigitalCert)" style="margin-right: 0px;">
                  {{ getStatusLabel(element.statusDigitalCert) }}
                </nz-tag>
              </mat-cell>
            </ng-container> -->
      
            <!-- Trạng thái ký NLĐ -->
            <ng-container matColumnDef="statusDigitalCertPersonal">
              <mat-header-cell *matHeaderCellDef
                               class="mat-header-cell-center status-col mat-cell-non-boder-right-bottom">
                {{ 'SEARCH_STANDARDIZED_LABOR_EMPLOYEE.EMPLOYEE_SIGNING_STATUS' | translate }}
              </mat-header-cell>
              <mat-cell *matCellDef="let element"
                        class="mat-header-cell-center status-col mat-cell-non-boder-right-bottom">        
                <nz-tag *ngIf="element.statusDigitalCertPersonal" [nzColor]="getStatusTagColor(element.statusDigitalCertPersonal)" style="margin-right: 0px;">
                  {{ getStatusLabel(element.statusDigitalCertPersonal) }}
                </nz-tag>
              </mat-cell>
            </ng-container>
      
            <!-- Trạng thái xác thực VNeID NLĐ -->
            <ng-container matColumnDef="statusVneidPersonal">
              <mat-header-cell *matHeaderCellDef
                               class="mat-header-cell-center status-col mat-cell-non-boder-right-bottom">
                {{ 'SEARCH_STANDARDIZED_LABOR_EMPLOYEE.EMPLOYEE_VNEID_VERIFICATION_STATUS' | translate }}
              </mat-header-cell>
              <mat-cell *matCellDef="let element"
                        class="mat-header-cell-center status-col mat-cell-non-boder-right-bottom">               
                <nz-tag *ngIf="element.statusVneidPersonal" [nzColor]="getStatusTagColor(element.statusVneidPersonal)" style="margin-right: 0px;">
                  {{ getStatusLabel(element.statusVneidPersonal) }}
                </nz-tag>
              </mat-cell>
            </ng-container>
      
            <!-- Trạng thái ký BBUQ NLĐ -->
            <ng-container matColumnDef="statusBbuqPersonal">
              <mat-header-cell *matHeaderCellDef
                               class="mat-header-cell-center status-col mat-cell-non-boder-right-bottom">
                  {{ 'SEARCH_STANDARDIZED_LABOR_EMPLOYEE.EMPLOYEE_AUTHORIZATION_RECORD_SIGNING_STATUS' | translate }}
                </mat-header-cell>
              <mat-cell *matCellDef="let element"
                        class="mat-header-cell-center status-col mat-cell-non-boder-right-bottom">            
                <nz-tag *ngIf="element.statusBbuqPersonal" [nzColor]="getStatusTagColor(element.statusBbuqPersonal)" style="margin-right: 0px;">
                  {{ getStatusLabel(element.statusBbuqPersonal) }}
                </nz-tag>
              </mat-cell>
            </ng-container>
      
            <!-- Thao tác -->
            <ng-container matColumnDef="action">
              <mat-header-cell *matHeaderCellDef
                               class="mat-header-cell-center action-col mat-cell">
                  {{ 'SEARCH_STANDARDIZED_LABOR_EMPLOYEE.ACTION' | translate }}
              </mat-header-cell>
              <mat-cell *matCellDef="let element"
                        class="mat-header-cell-center action-col mat-cell"
                        (click)="$event.stopPropagation()">
                <!-- Xem chi tiết -->
                <button mat-icon-button type="button" (click)="viewDetail(element)">
                  <mat-icon matTooltip="{{ 'enterprise_contract.tooltips.document_view' | translate }}">
                    visibility
                  </mat-icon>
                </button>
      
                <!-- Tải xuống -->
                <button mat-icon-button
                        type="button"
                        [disabled]="commonService.getIsLockedEnterprise()"
                        (click)="openPDFByBrowser(element)">
                  <mat-icon matTooltip="{{ 'enterprise_contract.buttons.download' | translate }}">
                    save_alt
                  </mat-icon>
                </button>
              </mat-cell>
            </ng-container>
      
            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
          </mat-table>
      
        </div>
      
        <!-- Pagination -->
        <app-pagination [(paginate)]="paginate"
                        (pageChange)="onFilterData($event.page, $event.pageSize)">
        </app-pagination>
      </mat-expansion-panel>
    </mat-accordion>
  
  
   
  
  </div>
  